import React, { useState } from 'react'
import LSMChart from '../components/ActivePurchased/LSMChart'
import { changeArrayItemState, resetActions } from '../components/common/show_and_hide'
import { sampleData } from '../mockups/Profile/marketplace'
import ConversationMetrics from '../components/ActivePurchased/ConversationMetrics'
import EmotionChart from '../components/ActivePurchased/EmotionChart'
import { useSelector } from 'react-redux'
import DatasetCard from '../components/MarketPlace/QueryComponent/DataSetCard'

function DataPurchased() {

  const data = useSelector(state => state.datasetReducer.fullData)
  const [opened, setOpened] = useState(Array.from({length : sampleData.length}, () => false))

  function toggleDiv(index){
    if (opened[index] === false) {
      resetActions(index, opened, setOpened)
    } else {
      changeArrayItemState(index, opened, setOpened)
    }
  }


  return (
    <div className='mb-5 mx-5 bg-white text-black px-3 py-5 sm:p-5 mt-[100px] rounded-lg'>

                <DatasetCard
                    {...data?.preview_data}
                    actionName="Active"
                    notPurchased={false}
                  />

    <div>
    {data?.full_data?.map((item, idx) => {

      const LSM = item?.psychometrics?.lsmScores
      const flow = item?.psychometrics?.conversation_flow
      const metrics = item?.psychometrics?.conversation_metrics
      //eslint-disable-next-line
      const psycho_analytic = item?.psychometrics?.psychoanalytic_profiler

      return <div key={idx} className='my-4' >
      <button
      onClick={() => {
        toggleDiv(idx)
      }}
       className='bg-enhancedTeal flex justify-between
      rounded-md w-full text-white p-3'>{item?.name}</button>

      {opened[idx] &&
      <div className='py-4 px-2 sm:p-4'>

      {LSM?.length > 0 && <LSMChart data={LSM} /> }
      {flow?.length > 0 && <ConversationMetrics conversation_data={flow} />}
      {metrics?.length > 0 && <EmotionChart emotionData={metrics} />}
      </div>}

      </div>
    })}

    </div>


    </div>
  )
}

export default DataPurchased
